/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UnitPriceSpec interface.
 */
export function instanceOfUnitPriceSpec(value) {
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('currency' in value) || value['currency'] === undefined)
        return false;
    if (!('tax' in value) || value['tax'] === undefined)
        return false;
    return true;
}
export function UnitPriceSpecFromJSON(json) {
    return UnitPriceSpecFromJSONTyped(json, false);
}
export function UnitPriceSpecFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amount': json['amount'],
        'currency': json['currency'],
        'tax': json['tax'],
    };
}
export function UnitPriceSpecToJSON(json) {
    return UnitPriceSpecToJSONTyped(json, false);
}
export function UnitPriceSpecToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amount': value['amount'],
    };
}
